<template>
  <div class="s-quick-tickets__selections">
    <div class="e-custom-select__container">
      <DropdownSelection
        v-model="selectedMovie"
        :placeholder="dictionary.movies"
        :observer-class="'s-hero-slider'"
        :options="moviesFilter"
        type="movie"
        @change="filterCinemasOptions">
        <template #selected="{ selectedOption }">
          {{ selectedOption.title }}
        </template>
        <template #image="{ option }">
          <img :src="option.thumb" :alt="option.title" />
        </template>
        <template #title="{ option }">
          {{ option.title }}
        </template>
        <template #subtitle="{ option }">
          <div v-html="option.subTitle"></div>
        </template>
      </DropdownSelection>

      <DropdownSelection
        v-model="selectedCinema"
        class="e-custom-select--theaters"
        :placeholder="dictionary.cinemas"
        :observer-class="'s-hero-slider'"
        :options="cinemasFilter"
        type="cinema"
        group-by="city"
        @change="filterMoviesOptions">
        <template #selected="{ selectedOption }">
          {{ selectedOption.display }}
        </template>
        <template #title="{ option }">
          {{ option.display }}
        </template>
        <template #subtitle="{ option }">
          <div v-html="option.address"></div>
        </template>
      </DropdownSelection>
    </div>

    <button
      type="button"
      class="s-quick-tickets__cta"
      :disabled="!showCtaBtn"
      @click="openBooking">
      <span>{{ dictionary.tickets }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, ref } from 'vue'
import DropdownSelection from '../components/Dropdown/DropdownSelection.vue'
import { getData } from '../../lib/lib'
import bookingRedirect from '../../lib/bookingRedirect'

const { dictionary, configuration } =
  getCurrentInstance().appContext.config.globalProperties

const { redirectIntoBooking } = bookingRedirect()

const { records, filters } = getData('quickBookingData')

const moviesFilter = ref([...records])
const cinemasFilter = ref([...filters.cinemas])

const selectedCinema = ref({})
const selectedMovie = ref({})

const showCtaBtn = computed(() => {
  return (
    Object.keys(selectedMovie.value).length > 0 &&
    Object.keys(selectedCinema.value).length > 0
  )
})

const filterCinemasOptions = (option) => {
  // filter cinemas options on change movies filter

  if (Object.keys(option).length) {
    cinemasFilter.value = [
      ...filters.cinemas.filter((cinema) =>
        option.cinemas.includes(cinema.value)
      ),
    ]

    resetOtherFilter('cinema')
  } else {
    cinemasFilter.value = [...filters.cinemas]
  }
}

const filterMoviesOptions = (option) => {
  // filter cinemas options on change movies filter
  if (Object.keys(option).length) {
    moviesFilter.value = [
      ...records.filter((movie) => movie.cinemas.includes(option.value)),
    ]
    resetOtherFilter('movie')
  } else {
    moviesFilter.value = [...records]
  }
}

const resetOtherFilter = (filterName) => {
  // in case user selected other filter and changed the other one, we need make sure the selected option is already in filters list
  if (filterName === 'cinema' && selectionNotEmpty(selectedCinema.value)) {
    selectedCinema.value = cinemasFilter.value.some(
      (cinema) => cinema.id === selectedCinema.value.id
    )
      ? { ...selectedCinema.value }
      : {}
  } else if (filterName === 'movie' && selectionNotEmpty(selectedMovie.value)) {
    selectedMovie.value = moviesFilter.value.some(
      (movie) => movie.id === selectedMovie.value.id
    )
      ? { ...selectedMovie.value }
      : {}
  }
}

const selectionNotEmpty = (selectedRef) => {
  return selectedRef && Object.keys(selectedRef).length > 0
}

const openBooking = () => {
  if (
    Object.keys(selectedMovie.value).length &&
    Object.keys(selectedCinema.value).length
  ) {
    redirectIntoBooking(
      configuration.baseUrl,
      selectedMovie.value.movieId,
      selectedCinema.value.value
    )
  }
}
</script>
